import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import { gsap } from "gsap";
import Alpine from "alpinejs";

Alpine.data('imageCarousel', () => ({
  swiper: null,

  init() {
    const swiperElement = this.$refs.swiper;
    this.swiper = new Swiper(swiperElement as any, {
      modules: [Navigation, Pagination],
      speed: 400,
      spaceBetween: 16,
      slidesPerView: 2,
      breakpoints: {
        1280: {
          slidesPerView: 3,
        }
      },
      navigation: {
        nextEl: ".c-image-carousel__button-next",
        prevEl: ".c-image-carousel__button-prev",
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets'
      }
    });
  },
  destroy() {
    this.swiper.destroy();
  }
}));
